import { useContext, ReactNode } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { CampusContext, CampusContextType, CampusFeatureFlags } from './CampusContext';
import AuthenticatedComponent from '../utilities/AuthenticatedComponent';
import configuration from '../config.js';

interface CampusContextProviderProps {
  children: ReactNode;
}

export const CampusContextProvider = ({ children }: CampusContextProviderProps) => {
  const campusId = useSelector((state: any) => state.currentCampusId);
  // const campusList = useSelector((state: any) => state.campuses);

  const fetchJson = async (url: string) => {
    const authenticatedComponent = new AuthenticatedComponent();
    const res = await fetch(url, { headers: authenticatedComponent.generateAuthenticatedHeader() });
    if (!res.ok) throw new Error(`Error: ${res.status}`);
    return res.json();
  };

  const {
    data: batteryData,
    // isLoading: batteryLoading,
    // error: batteryError,
  } = useQuery({
    queryKey: ['campus', campusId, 'battery'],
    queryFn: () => fetchJson(`${configuration['backend_host']}/ahiapi/${campusId}/acBatteries`),
    enabled: !!campusId,
  });

  // const currentCampus = campusList?.find((c: any) => c.campusEntityKey === campusId) ?? null;

  const campusHasBattery = (batteryData: any) => {
    if (!batteryData || batteryData.length === 0 || batteryData?.gridInterconnects?.length === 0) {
      return false;
    } else if (batteryData?.gridInterconnects?.length > 0) {
      const hasBattery = batteryData.gridInterconnects.some(
        (interconnect: any) => interconnect.acBatteries.length > 0
      );
      return hasBattery;
    }
    return true;
  };

  const featureFlags: CampusFeatureFlags = {
    hasBattery: batteryData ? campusHasBattery(batteryData) : false,
  };

  const contextValue: CampusContextType = {
    featureFlags,
  };

  return <CampusContext.Provider value={contextValue}>{children}</CampusContext.Provider>;
};

export const useCampusContext = (): CampusContextType => {
  const context = useContext(CampusContext);
  if (context === undefined) {
    throw new Error('useCampusContext must be used within a CampusContextProvider');
  }
  return context;
};

// hooks
export const useCampusFeatureFlags = (): CampusFeatureFlags => useCampusContext().featureFlags;
